import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import MobileHeader from "./components/MobileHeader";
import { Circles } from 'react-loader-spinner';
// import { faFacebook, faXTwitter, faWhatsapp, faInstagram, faYoutube } from "@fortawesome/free-brands-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FaVideo, FaHome, FaRegNewspaper, FaBookOpen, FaAngleDoubleRight } from 'react-icons/fa';
// import { FaNewspaper } from "react-icons/fa";
import india from './india.png'

// import './Header.css';

const truncateText = (text, maxLength) => {
  if (text.length > maxLength) {
    return text.substring(0, maxLength);
  }
  return text;
};
const stripHtmlTags = (html, maxLength) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  const strippedText = tempDiv.textContent || tempDiv.innerText || "";
  return truncateText(strippedText, maxLength);
};
export default function Header() {
  const [darkMode, setDarkMode] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    return savedTheme === 'dark';
  });

  useEffect(() => {
    localStorage.setItem('theme', darkMode ? 'dark' : 'light');
    if (darkMode) {
      document.body.classList.add('dark');
    } else {
      document.body.classList.remove('dark');
    }
  }, [darkMode]);

  const toggleDarkMode = () => {
    setDarkMode(prevMode => !prevMode);
  };

  const [newsData, setPosts] = useState([]);
  const [secondData, setSecondData] = useState([]);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);




  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://api.shabdtoday.com/api/home/breaking"
        );
        setPosts(response.data);
        setLoading(false);
      } catch (error) {
        setError(error.message);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // useEffect(() => {
  //   const fetchSecondData = async () => {
  //     try {
  //       const secondResponse = await axios.get(
  //         "https://api.shabdtoday.com/api/home/state"
  //       );
  //       console.log("API Response:", secondResponse.data); // <-- Add this
  //       setSecondData(secondResponse.data);
  //     } catch (error) {
  //       console.error("Error fetching second data:", error);
  //     }
  //   };

  //   fetchSecondData();
  // }, []);

  useEffect(() => {
    const fetchSecondData = async () => {
      try {
        const secondResponse = await axios.get(
          "https://api.shabdtoday.com/api/home/getState"
        );
        setSecondData(secondResponse.data);
      } catch (error) {
        console.error("Error fetching second data:", error);
      }
    };

    fetchSecondData();
  }, []);

  // if (loading) {
  //   return (
  //     <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
  //       <Circles
  //         height="30"
  //         width="30"
  //         color="#f7265c"
  //         ariaLabel="circles-loading"
  //         wrapperStyle={{}}
  //         wrapperClass=""
  //         visible={true}
  //       />
  //     </div>
  //   );
  // }

  if (error) {
    return <div>Error: {error}</div>;
  }
  return (
    <div>
      <div className="my-component">
        <div className="ak-bar ak-header-bar ak-top-bar ak-bar-dark full-width clearfix newheader" style={{ background: "#ff003b" }} >
          {/* <div className="container">
            <div className="ak-bar-inner">
              <div className="ak-row ak-row-items-middle">
                <div className="ak-column ak-column-left ak-column-grow">
                  <div className="ak-inner-row ak-row-items-middle ak-justify-content-left">
                    <div className="ak-bar-item ak-header-newsticker">
                      <div className="ak-block ak-block-newsticker dark ak-block-width-1 ak-slider-container clearfix" id="block_65f7f61f36732_1">
                        <div className="ak-block-header1  ak-block-header ak-block-header-style-8 no-tabs">
                          <h1 className="ak-block-title1">
                            <span className="title-text">
                              <i className="ak-icon1 ak-fi akfi-flash_on"></i>
                              <span>ब्रेकिंग</span>
                            </span>
                          </h1>
                        </div>

                         <div className="ak-block-inner clearfix">
                          <div className="ak-block-posts clearfix">
                            {newsData.breaking.map((item, index) => (
                              <div key={item.mainKhabarId} className="ak-newsticker-item">
                                <span>
                                  <Link to={`/MadhyaPradeshDetailsD/${item.mainKhabarId}`} aria-label={stripHtmlTags(item.newsHeading, 150)} >
                                    {stripHtmlTags(item.newsHeading, 150)}
                                  </Link>
                                </span>
                              </div>
                            ))}  </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ak-column ak-column-right ak-column-normal">
                  <div className="ak-inner-row ak-row-items-middle ak-justify-content-right">
                    <div className="ak-bar-item ak-header-social-icons">
                      <ul className="ak-social-counter social-counter-style-4 social-counter-light clearfix dark" style={{ background: "#ff003b" }}>

                        <li className="social-item">
                          <Link to="https://www.facebook.com" aria-label="Facebook" className=" facebook" target="_blank" rel="external noopener nofollow">
                            <FontAwesomeIcon icon={faFacebook} style={{ color: "#fff", fontSize: "24px" }} /> </Link>   </li>

                        <li className="social-item">
                          <Link to="https://www.whatsapp.com" aria-label="Whatsapp" className=" Whatsapp" target="_blank" rel="external noopener nofollow">
                            <FontAwesomeIcon icon={faWhatsapp} style={{ color: "#fff", fontSize: "24px" }} /> </Link>   </li>

                        <li className="social-item">
                          <Link to="https://www.twitter.com" aria-label="Twitter" className=" twitter" target="_blank" rel="external noopener nofollow" >
                            <FontAwesomeIcon icon={faXTwitter} style={{ color: "#fff", fontSize: "24px" }} />   </Link>
                        </li>

                        <li className="social-item">
                          <Link to="https://www.youtube.com" aria-label="Youtube" className=" youtube" target="_blank" rel="external noopener nofollow">
                            <FontAwesomeIcon icon={faYoutube} style={{ color: "#fff", fontSize: "24px" }} />   </Link>   </li>

                        <li className="social-item">
                          <Link to="https://www.instagram.com" aria-label="Youtube" className=" youtube" target="_blank" rel="external noopener nofollow" >
                            <FontAwesomeIcon icon={faInstagram} style={{ color: "#fff", fontSize: "24px" }} />    </Link> </li>   </ul>   </div>
                    <div className="ak-bar-item ak-header-divider divider3" />   </div>  </div>  </div> </div>
          </div> */}
        </div>
        <div className="ak-bar ak-header-bar ak-mid-bar ak-bar-dark full-width clearfix" style={{ background: "#ff003b" }}>
          <div className="container">
            <div className="ak-bar-inner">
              <div className="ak-row ak-row-items-middle">
                <div className="ak-column ak-column-left ak-column-grow">
                  <div className="ak-inner-row ak-row-items-middle ak-justify-content-left">
                    <div className="ak-bar-item ak-header-menu-handler ">
                      <Link to="/" className="ak-menu-handler" aria-label="offcanvas With Both Options" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" aria-controls="offcanvasWithBothOptions">
                        <span />
                        <span />
                        <span />
                      </Link>
                    </div>
                    <div className="ak-bar-item ak-header-divider divider2" />
                    <div className="ak-bar-item ak-dark-mode">
                      <div className="ak-toggle-container">
                        <label htmlFor="dark_mode">
                          <span className="screen-reader-text">Dark mode</span>
                        </label>
                        <input
                          id="dark_mode"
                          onClick={toggleDarkMode}
                          type="checkbox"
                          className="ak-dark-mode-toggle"
                          checked={darkMode} // Ensure checkbox reflects state
                        />
                        <span className="slider round" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ak-column ak-column-center ak-column-normal logo-img">
                  <div className="ak-inner-row ak-row-items-middle ak-justify-content-center">
                    <div className="ak-bar-item ak-header-logo">
                      <h1 className="site-title ak-logo-wrap ak-logo-image">
                        <Link to="/" aria-label="Shabd Today logo">
                          <picture>
                            <img
                              className="site-logo"
                              width={237}
                              height={100}
                              loading="lazy"
                              src="/design/images/logo-s.webp"
                              alt="शब्द टुडे  Logo"
                            />
                          </picture>
                        </Link> </h1>  </div> </div> </div>
                {/* <div className="ak-column ak-column-right ak-column-grow">
                  <div className="ak-inner-row ak-row-items-middle ak-justify-content-right">
                    <div className="ak-bar-item ak-header-button ak-header-button2">
                      <Link to="/Epaper-News" className="btn" aria-label="हिंदी न्यूज़ समाचार"> ई-पेपर</Link>  </div>
                    <div className="ak-bar-item ak-header-button ak-header-button2">
                      <Link to="/Webstorie-News" className="btn" aria-label="हिंदी न्यूज़ समाचार"> वेब स्टोरीज</Link>  </div>
                    <div className="ak-bar-item ak-header-divider divider1" />
                    <div className="ak-bar-item ak-header-button ak-header-button3">
                      <Link to="/LiveNews" className="btn round" aria-label=" लाइव न्यूज़ ">
                        <FaVideo style={{ color: 'red' }} />
                        <span style={{ marginLeft: 5 }}>लाइव न्यूज़</span> </Link>
                    </div>
                  </div>
                </div> */}
                <div className="ak-column ak-column-right ak-column-grow">
                  <div className="ak-inner-row ak-row-items-middle ak-justify-content-right">

                    {/* Web Stories */}
                    <div className="ak-bar-item ak-header-button ak-header-button2">
                      <Link to="/Webstorie-News" className="btn" aria-label="वेब स्टोरीज">
                        <FaBookOpen size={20} style={{ marginRight: 5 }} />वेब स्टोरीज
                      </Link>
                    </div>

                    {/* E-paper */}
                    <div className="ak-bar-item ak-header-button ak-header-button2">
                      <Link to="/Epaper-News" className="btn" aria-label="ई-पेपर">
                        <FaRegNewspaper size={20} style={{ marginRight: 5 }} />ई-पेपर
                      </Link>
                    </div>

                    {/* Divider */}
                    <div className="ak-bar-item ak-header-divider divider1" />

                    {/* Live News */}
                    {/* <div className="ak-bar-item ak-header-button ak-header-button3">
                      <Link to="/LiveNews" className="btn round live-news-btn" aria-label="लाइव न्यूज़">
                        <FaVideo size={18} style={{ color: "red", marginRight: 6 }} />
                        <span>लाइव न्यूज़</span>
                      </Link>
                    </div>
 */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Mobile Navbar */}
      <div className="offcanvas offcanvas-start bg-red" data-bs-scroll="true" tabIndex={-1} id="offcanvasWithBothOptions" role="dialog" aria-label="offcanvas With Both Options" aria-modal="true" style={{ visibility: "visible" }} >
        <div className="offcanvas-header border-bottom mobilenavbg">
          <div className="pt-2">
            <Link to="/" data-bs-dismiss="offcanvas" aria-label="Shabd Today logo">
              <img src="/design/images/logo-s.webp" style={{ height: 100, width: 250 }}
                loading="lazy" alt="Shabd today" />
            </Link>
          </div>
          <button type="button" className="btn-close text-reset sidebarclose" data-bs-dismiss="offcanvas" aria-label="Close" />
        </div>
        <div className="offcanvas-body mobilenavbg">

          <div className="pt-2">
            <Link to="/TajaKhabar-News">
              <button className="btn" type="button" data-bs-dismiss="offcanvas" aria-expanded="false" aria-label="Taza Khabar">ताजा खबरें</button>

            </Link>
          </div>

          <div className="pt-2">
            <Link to="/Khel-News">
              <button className="btn" type="button" data-bs-dismiss="offcanvas" aria-expanded="false" aria-label="khel">खेल </button> </Link>
          </div>

          <div className="pt-2">
            <Link to="/Technology-News">
              <button className="btn" type="button" data-bs-dismiss="offcanvas" aria-expanded="false" aria-label="rashifal" > टेक्नोलॉजी</button></Link>
          </div>

          <div className="pt-2">
            <Link to="/Buisness-News">
              <button className="btn" type="button" data-bs-dismiss="offcanvas" aria-expanded="false" aria-label="business">  बिज़नेस</button> </Link>
          </div>

          <div className="pt-2">
            <Link to="/Buisness-News">
              <button className="btn" type="button" data-bs-dismiss="offcanvas" aria-expanded="false" aria-label="business">  दुनिया </button> </Link>
          </div>

          <div className="pt-2">
            <Link to="/Politics-News">
              <button className="btn" type="button" data-bs-dismiss="offcanvas" aria-expanded="false" aria-label="Politics">  पॉलिटिक्स </button> </Link>
          </div>

          <div className="pt-2">
            <Link to="/Bollywood-News">
              <button className="btn" type="button" data-bs-dismiss="offcanvas" aria-expanded="false" aria-label="bollywood">बॉलीवुड </button></Link>
          </div>

          <div className="pt-2">
            <Link to="/Daram-News">
              <button className="btn" type="button" data-bs-dismiss="offcanvas" aria-expanded="false" aria-label="dharm"> धर्म </button> </Link>
          </div>
          <div className="pt-2">
            <Link to="/National-News">
              <button className="btn" type="button" data-bs-dismiss="offcanvas" aria-expanded="false" aria-label="dharm"> देश </button> </Link>
          </div>
          <div className="pt-2">
            <Link to="/MadhyaPradesh-News">
              <button className="btn" type="button" data-bs-dismiss="offcanvas" aria-expanded="false" aria-label="Mp">मध्य प्रदेश</button> </Link>
          </div>

          <div className="pt-2">
            <Link to="/Chhattisgarh-News">
              <button className="btn" type="button" data-bs-dismiss="offcanvas" aria-expanded="false" aria-label="CG"> छत्तीसगढ़</button></Link>
          </div>


          {/* <div className="pt-2">
            <Link to="/International">
              <button className="btn" type="button" data-bs-dismiss="offcanvas" aria-expanded="false" aria-label="international"> अन्तर्राष्ट्रीय </button>
            </Link>
          </div> */}

          <div className="pt-2">
            <Link to="/Daram-News">
              <button className="btn" type="button" data-bs-dismiss="offcanvas" aria-expanded="false" aria-label="dharm"> लाइफस्टाइल  </button> </Link>
          </div>

          {/* <div className="pt-2">
            <Link to="/DaramDetails">
              <button className="btn" type="button" data-bs-dismiss="offcanvas" aria-expanded="false" aria-label="dharm"> करेंट अफेयर्स   </button> </Link>
          </div> */}

          {/* <div className="pt-2">
            <Link to="/DaramDetails">
              <button className="btn" type="button" data-bs-dismiss="offcanvas" aria-expanded="false" aria-label="dharm"> टेक-ऑटो   </button> </Link>
          </div> */}

          <div className="pt-2">
            <Link to="/Rashifal-News">
              <button className="btn" type="button" data-bs-dismiss="offcanvas" aria-expanded="false" aria-label="rashifal" > राशिफल</button></Link>
          </div>

          <div className="pt-2">
            <Link to="/Opinions">
              <button className="btn" type="button" data-bs-dismiss="offcanvas" aria-expanded="false" aria-label="/Opinions" > ओपिनियन</button></Link>
          </div>

          <div className="pt-2">
            <Link to="/jansampark">
              <button className="btn" type="button" data-bs-dismiss="offcanvas" aria-expanded="false" aria-label="/jansampark" > Jansampark RSS</button></Link>
          </div>

          <div className="pt-2">
            <Link to="/Webstorie-News">
              <button className="btn" type="button" data-bs-dismiss="offcanvas" aria-expanded="false" aria-label="Webseries" >वेब स्टोरीज </button></Link>
          </div>
          <div className="pt-2">
            <Link to="/Video-News">
              <button className="btn" data-bs-dismiss="offcanvas" type="button" aria-expanded="false" aria-label="video" > वीडियो  </button> </Link>
          </div>
          <div className="pt-2">
            <Link to="/Epaper-News">
              <button className="btn" data-bs-dismiss="offcanvas" type="button" aria-expanded="false" aria-label="video" > ई-पेपर  </button> </Link>
          </div>

          {/* <div className="pt-2">
            <Link to="/Wether">
              <button className="btn" type="button" data-bs-dismiss="offcanvas" aria-expanded="false" aria-label="mousam"> मौसम</button> </Link> </div> */}
          <div className="pt-2">
            <Link to=""> <button className="btn" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight" aria-expanded="false" aria-label="state">अन्य राज्य</button> </Link>
          </div>
        </div>
      </div>
      {/* Desktop NavBar */}
      <div className="ak-bar ak-header-bar ak-bottom-bar full-width clearfix my-component">
        <div className="container" style={{ borderBottom: "0.5px solid gray", padding: "5px" }}>
          <div className="ak-bar-inner">
            <div className="ak-row ak-row-items-middle">
              {/* Home Icon Column - Added right padding */}
              <div className="ak-column ak-column-left" style={{ flex: '0 0 auto', paddingRight: '20px' }}>
                <div className="ak-inner-row ak-row-items-middle ak-justify-content-left">
                  <div className="ak-bar-item ak-header-home-button">
                    <Link to="/" className="ak-header-icon-btn ak-header-home-btn" aria-label="Desktop NavBar">
                      <FaHome />
                    </Link>
                  </div>
                </div>
              </div>

              {/* Scrollable Menu Column */}
              <div className="ak-column ak-column-center" style={{ flex: '1 1 auto', minWidth: 0 }}>
                <div className="ak-inner-row ak-row-items-middle ak-justify-content-center">
                  <div className="ak-bar-item ak-header-main-menu ak-menu-more-enabled">
                    <div style={{
                      overflowX: 'auto',
                      WebkitOverflowScrolling: 'touch',
                      scrollbarWidth: 'none',
                      msOverflowStyle: 'none',
                      marginBottom: "1px solid grey"
                    }}>
                      <ul
                        id="menu-main-navigation"
                        className="ak-menu ak-main-menu ak-menu-wide ak-menu-style-3 ak-main-menu"
                        style={{
                          display: 'inline-flex',
                          flexWrap: 'nowrap',
                          padding: '0 10px',
                          listStyle: 'none',
                          gap: '15px' // Added gap between menu items
                        }}
                      >
                        {/* Your menu items here - keep all existing li elements */}
                        <li id="menu-item-254" className="menu-item" style={{ flexShrink: 0 }}>
                          <Link to="/Live-News" aria-label="लाइव न्यूज़">
                            <div className="d-flex align-items-center">
                              <FaVideo style={{ color: 'red', fontSize: '18px' }} />
                              <span style={{ marginLeft: 5, fontSize: "15px" }}>लाइव न्यूज़</span>
                            </div>
                          </Link>
                        </li>
                        <li id="menu-item-254" className="menu-item " style={{ flexShrink: 0 }}>
                          <Link to="/TajaKhabar-News"> <span style={{ fontSize: "15px" }}>🗞️ ताजा खबरें</span>
                          </Link>

                        </li>

                        <li id="menu-item-259" className="menu-item" style={{ flexShrink: 0 }}>
                          <Link to="/Khel-News"> <span style={{ fontSize: "15px" }}>🏏 खेल</span> </Link>
                        </li>

                        <li id="menu-item-258" className="menu-item " style={{ flexShrink: 0 }}>
                          <Link to="/Technology-News"> <span style={{ fontSize: "15px" }}>💻 टेक्नोलॉजी</span> </Link>
                        </li>

                        <li id="menu-item-260" className="menu-item" style={{ flexShrink: 0 }}>
                          <Link to="/Buisness-News"> <span style={{ fontSize: "15px" }}>💼 बिज़नेस</span> </Link>
                        </li>

                        <li id="menu-item-260" className="menu-item" style={{ flexShrink: 0 }}>
                          <Link to="/World-News"> <span style={{ fontSize: "15px" }}>🌍 दुनिया</span> </Link>
                        </li>

                        <li id="menu-item-260" className="menu-item" style={{ flexShrink: 0 }} >
                          <Link to="/Politics-News"> <span style={{ fontSize: "15px" }}>🏛️ पॉलिटिक्स</span> </Link>
                        </li>

                        <li id="menu-item-260" className="menu-item" style={{ flexShrink: 0 }}>
                          <Link to="/Bollywood-News"> <span style={{ fontSize: "15px" }}>🎬 बॉलीवुड</span> </Link>
                        </li>

                        <li id="menu-item-257" className="menu-item " style={{ flexShrink: 0 }}>
                          <Link to="/Daram-News"> <span style={{ fontSize: "15px" }}>🛕 धर्म</span> </Link>
                        </li>

                        <li id="menu-item-257" className="menu-item " style={{ flexShrink: 0 }}>
                          <Link to="/National-News">
                            <span className="d-flex align-items-center">
                              <img src={india} alt="Logo" style={{ maxWidth: 20 }} />
                              <span style={{ fontSize: "15px" }}>देश</span>
                            </span>
                          </Link>
                        </li>

                        <li id="menu-item-253" className="menu-item " style={{ flexShrink: 0 }}>
                          <Link to="/MadhyaPradesh-News">  <span style={{ fontSize: "15px" }}>🌾 मध्यप्रदेश</span> </Link>
                        </li>

                        <li id="menu-item-254" className="menu-item " style={{ flexShrink: 0 }}>
                          <Link to="/Chhattisgarh-News"><span style={{ fontSize: "15px" }}>🌿 छत्तीसगढ़</span> </Link>
                        </li>

                        {/* <li id="menu-item-256" className="menu-item menu-item-type-taxonomy menu-item-object-category menu-term-50 menu-item-256" >
                        <Link to="/International"> <span>अन्तर्राष्ट्रीय </span> </Link>
                      </li> */}

                        {/* <li id="menu-item-260" className="menu-item"   >
                        <Link to="/PhotoMovieGalleryPage"> <span>फोटो गैलरी </span>  </Link>
                      </li> */}

                        <li id="menu-item-260" className="menu-item" style={{ flexShrink: 0 }} >
                          <Link to="/LifeStyle-News"><span style={{ fontSize: "15px" }}>💖 लाइफस्टाइल</span> </Link>
                        </li>

                        <li id="menu-item-258" className="menu-item" style={{ flexShrink: 0 }}>
                          <Link to="/Rashifal-News"> <span style={{ fontSize: "15px" }}>🔮 राशिफल</span> </Link>
                        </li>

                        <li id="menu-item-258" className="menu-item" style={{ flexShrink: 0 }}>
                          <Link to="/jansampark"> <span style={{ fontSize: "15px" }}>📡 Jansampark RSS</span> </Link>
                        </li>

                        <li id="menu-item-258" className="menu-item" style={{ flexShrink: 0 }}>
                          <Link to="/Opinions"> <span style={{ fontSize: "15px" }}>💬 ओपिनियन</span> </Link>
                        </li>

                        {/* <li id="menu-item-260" className="menu-item" >
                        // <Link to="/Epaper" target="blank"> <span>करेंट अफेयर्स</span> </Link>
                      </li> */}


                        {/* <li id="menu-item-260" className="menu-item" >
                        <Link to="/Epaper" target="blank"> <span>टेक-ऑटो </span> </Link>
                      </li> */}

                        {/* <li id="menu-item-260" className="menu-item" >
                        <Link to="/WebstorieDetails">  <span>वेब स्टोरीज </span> </Link>
                      </li> */}
                        <li id="menu-item-260" className="menu-item" style={{ flexShrink: 0 }}>
                          <Link to="/Video-News">  <span style={{ fontSize: "15px" }}>🎥 वीडियो</span> </Link>
                        </li>

                        <li id="menu-item-260" className="menu-item" style={{ flexShrink: 0 }}>
                          <Link to="/PrivacyPolicy">  <span style={{ fontSize: "15px" }}>Privacy Policy</span> </Link>
                        </li>

                        <li id="menu-item-260" className="menu-item" style={{ flexShrink: 0 }}>
                          <Link to="/ContactUs">  <span style={{ fontSize: "15px" }}>Contact Us</span> </Link>
                        </li>
                        {/* <li id="menu-item-260" className="menu-item" >
                        <Link to="/Wether"> <span>मौसम </span> </Link>
                      </li> */}

                        <li id="menu-item-254" className="menu-item " style={{ flexShrink: 0 }}  >
                          <Link data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight" style={{ fontSize: "15px" }}> <span>🧭 अन्य राज्य</span> </Link>
                        </li>

                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              {/* Search Column */}
              {/* <div className="ak-column ak-column-right ak-column-grow">
                <div className="ak-inner-row ak-row-items-middle ak-justify-content-right">
                  <div className="ak-bar-item ak-header-search">
                    <Link to="#" className="ak-header-icon-btn ak-dropdown-button ak-search-btn" aria-label="Search">
                      <FaAngleDoubleRight />
                    </Link>
                    <div className="ak-dropdown ak-search-box clearfix" data-event="click"></div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>

      <div className="offcanvas offcanvas-end" tabIndex={-1} id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
        <div className="offcanvas-header bg-red border-bottom">
          <h5 className="offcanvas-title text-white " id="offcanvasBottomLabel">  अन्य राज्य</h5>
          <button type="button" className="btn-close sidebarclose" data-bs-dismiss="offcanvas" aria-label="Close" />  </div>
        <div className="offcanvas-body bg-red">
          <div className="astronews">
            <div className="block">
              {!secondData ? (
                <div>Loading...</div>
              ) : secondData.statenames && secondData.statenames.length > 0 ? (
                secondData.statenames.map((newsItem) => (
                  <div key={newsItem.state_id} className="itemm" data-bs-dismiss="offcanvas">
                    {/* <Link to={`/OtherState-News/${newsItem.stateESlug}`} className="astro">
                      <div className="title">{newsItem.state_title}</div>
                    </Link> */}
                    <Link to={`/${newsItem.stateESlug}`} className="astro">
                      <div className="title">{newsItem.state_title}</div>
                    </Link>
                  </div>
                ))
              ) : (
                <div>No states found.</div>
              )}
            </div>
          </div>
        </div>
      </div>
      <MobileHeader />
    </div>
  );
}
